import React from "react";
import { CTALink } from "@/components/common/CTALink";
import { Reveal } from "@/components/common/Reveal";
import * as Icons from "lucide-react";

/**
 * Standard hero for solution / inner pages. Left copy, right slot for visual.
 */
export const PageHero = ({ eyebrow, icon, title, description, primary, secondary, note, visual, compact = false }) => {
  const Icon = icon ? Icons[icon] : null;
  return (
    <section className="relative overflow-hidden et-hero-wash">
      <div className="absolute inset-0 et-dot-grid opacity-[0.35] pointer-events-none" />
      <div className={`et-container relative ${compact ? "py-16 lg:py-20" : "py-16 sm:py-20 lg:py-24"}`}>
        <div className={`grid ${visual ? "lg:grid-cols-2" : ""} gap-12 lg:gap-16 items-center`}>
          <div className={visual ? "" : "max-w-3xl"}>
            {eyebrow && (
              <Reveal>
                <span className="et-eyebrow">
                  {Icon && <Icon className="h-3.5 w-3.5" />} {eyebrow}
                </span>
              </Reveal>
            )}
            <Reveal delay={0.05}>
              <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mt-5 leading-[1.1]">
                {title}
              </h1>
            </Reveal>
            {description && (
              <Reveal delay={0.1}>
                <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl">{description}</p>
              </Reveal>
            )}
            {(primary || secondary) && (
              <Reveal delay={0.15}>
                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  {primary && <CTALink to={primary.to} variant="primary" withArrow>{primary.label}</CTALink>}
                  {secondary && <CTALink to={secondary.to} variant="secondary">{secondary.label}</CTALink>}
                </div>
              </Reveal>
            )}
            {note && (
              <Reveal delay={0.2}>
                <p className="mt-5 flex items-start gap-2 text-xs text-slate-500 max-w-lg">
                  <Icons.ShieldCheck className="h-4 w-4 text-[var(--et-primary)] mt-0.5 shrink-0" /> {note}
                </p>
              </Reveal>
            )}
          </div>
          {visual && (
            <Reveal delay={0.15} className="relative">
              {visual}
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
};
